'use client';

import React from 'react';
import { SVG_SIZE_S } from 'src/constants';
import { Icon as CommonIcon } from 'src/components/Icon';
import { PlanFeatureItem } from 'src/types';
import styles from './PlanCardContentItem.module.scss';

export const PlanCardContentItem = ({
  Icon: IconComponent,
  iconName,
  title,
  description,
  modelList,
  hideAndMoreModels,
}: PlanFeatureItem) => {
  return (
    <div className={styles.featureItem}>
      {iconName ? (
        <CommonIcon type={iconName} size={SVG_SIZE_S} />
      ) : IconComponent ? (
        React.createElement(IconComponent, { size: SVG_SIZE_S })
      ) : null}

      <div className={styles.textWrapper}>
        <div className={styles.title}>{title}</div>

        {!!description && (
          <span className={styles.description}>{description}</span>
        )}

        {modelList && (
          <div className={styles.modelList}>
            {modelList.map(({ title, iconName, Icon: ModelIcon }, index) => (
              <div key={index} className={styles.modelItem}>
                {iconName ? (
                  <CommonIcon type={iconName} size={SVG_SIZE_S} />
                ) : ModelIcon ? (
                  React.createElement(ModelIcon, { size: SVG_SIZE_S })
                ) : null}

                <span className={styles.description}>
                  {title}
                  {hideAndMoreModels && index === modelList.length - 1
                    ? ''
                    : ', '}
                </span>
              </div>
            ))}

            {!hideAndMoreModels && (
              <span className={styles.description}>and more</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
